/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateCart201ResponseAllOfData } from './CreateCart201ResponseAllOfData';
import {
    CreateCart201ResponseAllOfDataFromJSON,
    CreateCart201ResponseAllOfDataFromJSONTyped,
    CreateCart201ResponseAllOfDataToJSON,
} from './CreateCart201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateCart201ResponseAllOf
 */
export interface CreateCart201ResponseAllOf {
    /**
     * 
     * @type {CreateCart201ResponseAllOfData}
     * @memberof CreateCart201ResponseAllOf
     */
    data: CreateCart201ResponseAllOfData;
}

/**
 * Check if a given object implements the CreateCart201ResponseAllOf interface.
 */
export function instanceOfCreateCart201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CreateCart201ResponseAllOfFromJSON(json: any): CreateCart201ResponseAllOf {
    return CreateCart201ResponseAllOfFromJSONTyped(json, false);
}

export function CreateCart201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCart201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateCart201ResponseAllOfDataFromJSON(json['data']),
    };
}

export function CreateCart201ResponseAllOfToJSON(value?: CreateCart201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateCart201ResponseAllOfDataToJSON(value.data),
    };
}

